import common from './common';

export default {
  ...common,
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/staging/featureFlagsStaging.json',
  firebaseConfig: {
    ...common.firebaseConfig,
    appId: '1:81318095329:web:d74335ddb0e7c2a4180aa0',
  },
};
